module.exports = __webpack_public_path__ + "static/media/ic_familiares.03f29a15.svg";